<template>
  <div id="pos" class="vs-con-loading__container flex">
    <div class="w-9/12 mr-3">
      <div class="pos_header vx-card p-6 mb-5">
        <!-- invoice header -->
        <div class="pos__header">
          <h4>Sales Invoice</h4>
        </div>
        <hr class="mt-3 mb-5" />

        <!-- pos header - customer option -->
        <pos-header ref="pos_header" :viewRendered="true" :customer.sync="customer" :customerDetail="customerDetail" @customerChangeHandler="customerChangeHandler" />

        <!-- select customer reward points -->
        <div class="flex flex-wrap items-center mt-5 reward-points" v-if="customer && redeemPointSettings">
          <div>Your Reward Points: {{ Math.ceil(customerDetail.reward_points) }}</div>
          <div class="ml-4 flex items-center" v-if="customerDetail.reward_points > 0">
            <div class="mx-4 flex items-center">
              <vs-radio v-model="reedemType" vs-value="all">Use All Points</vs-radio>
            </div>
            <div class="mx-4 flex items-center">
              <vs-radio v-model="reedemType" vs-value="partial">Use Partial Points</vs-radio>
              <vs-input-number
                v-if="reedemType === 'partial'"
                class="m-0 ml-4"
                :value="Math.round(redeemPoints)"
                :min="0"
                :max="customerDetail.reward_points"
                :max-decimal="0"
                @input="
                  (item) => {
                    setRedeemPoints(item)
                  }
                "
                :step="1"
              />
            </div>
            <div class="mx-4 flex items-center" v-if="reedemType">
              <vs-button
                color="danger"
                icon="close"
                @click="
                  () => {
                    this.redeemPoints = this.tempRedeemPoints = 0
                    reedemType = null
                  }
                "
                >Clear Selection</vs-button
              >
            </div>
          </div>
        </div>
      </div>

      <!-- package list -->
      <product-list @product-clicked="addProductItemsInInvoice" @setCategoryTaxes="setCategoryTaxes" />

      <div id="pos__invoice" class="mt-5">
        <!-- invoice column -->
        <div class="vx-card p-6 mb-4">
          <!-- invoice product details -->
          <vs-table :data="invoice__products" class="invoice__product__details vs-con-loading__container mt-5 border border-solid">
            <template slot="thead">
              <vs-th>Item Name</vs-th>
              <vs-th>Weight Type</vs-th>
              <vs-th>Quantity</vs-th>
              <vs-th>Add Discount</vs-th>
              <vs-th>Redeem Points</vs-th>
              <vs-th>Price</vs-th>
              <vs-th>Subtotal</vs-th>
              <vs-th>Discount Amount</vs-th>
              <vs-th>Tax Amount</vs-th>
              <vs-th>x</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <!-- Item Name -->
                <vs-td class="product_name" :data="data[indextr].product_name">
                  {{ data[indextr].product_name }}
                </vs-td>

                <!-- weight type -->
                <vs-td class="weight_types">
                  <select-2
                    v-if="data[indextr].categoryId === categories.FLOWER || data[indextr].categoryId === categories.SHAKE"
                    autocomplete
                    class="w-full"
                    :value="data[indextr].weight_type"
                    @input="(item) => changeWeightType(indextr, item.value)"
                    placeholder="Select Weight Type"
                    :options="weightTypesOptions"
                  />
                </vs-td>

                <!-- quantity -->
                <vs-td>
                  <vs-input-number
                    v-if="![categories.PLANT, categories.MATURE].includes(data[indextr].categoryId)"
                    :value="data[indextr].itemQuantity"
                    :max-decimal="3"
                    :step="data[indextr].categoryId === categories.FLOWER || data[indextr].categoryId === categories.SHAKE ? 0.5 : 1"
                    :min="0"
                    :max="data[indextr].maxAvailableQuantity"
                    @input="productQtyChangeHandler(tr, indextr, $event)"
                  />

                  <vs-input v-else disabled class="inputx itemQuantity" v-model="data[indextr].itemQuantity" />
                </vs-td>

                <!-- discount -->
                <vs-td>
                  <vs-button v-if="data[indextr].price > 0" type="filled" color="dark" size="small" @click="toggleDiscountSettingModal(tr, indextr)"> Add Discount </vs-button>
                </vs-td>

                <!-- redeem points -->
                <vs-td>
                  {{ tr.item_redeem_points }}
                </vs-td>

                <!-- price -->
                <vs-td class="price">
                  <vs-input
                    v-if="GROWER_SUB_USER.concat(PROCESSOR_SUB_USER).includes(user.roleId)"
                    class="w-full min-w-max"
                    @change="(e) => productPriceChangeHandler(tr, e.target.value)"
                    :value="data[indextr].price | currencyFilter"
                    v-validate="'required'"
                  />
                  <span v-else>{{ tr.price | currencyFilter }}</span>
                </vs-td>

                <!-- subtotal -->
                <vs-td>
                  {{ render_sub_total(tr) | currencyFilter }}
                </vs-td>

                <!-- discount amount -->
                <vs-td>
                  {{ tr.discountAmount | currencyFilter }}
                </vs-td>

                <!-- tax amount -->
                <vs-td>
                  {{ data[indextr].tax | currencyFilter }}
                </vs-td>

                <!-- remove item -->
                <vs-td>
                  <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="removeProductFromInvoice(indextr)" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <!-- tax panel -->
          <div class="tax__panel border border-solid rounded mt-5">
            <div class="vx-row m-0">
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 flex items-center justify-around p-6">
                City Tax:
                <vs-input type="number" disabled class="min-w-max ml-2" :value="cityTax | currencyFilter" v-validate="'required'" />
                <vs-checkbox v-model="isCitytax_apply" :disabled="verifyCheckboxDisable('city_tax')"></vs-checkbox>
              </div>
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 flex items-center justify-around p-6">
                State Tax:
                <vs-input type="number" disabled class="min-w-max ml-2" :value="stateTax | currencyFilter" v-validate="'required'" />
                <vs-checkbox v-model="isStatetax_apply" :disabled="verifyCheckboxDisable('state_tax')"></vs-checkbox>
              </div>
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 flex items-center justify-around p-6">
                Excise Tax:
                <vs-input type="number" disabled class="min-w-max ml-2" :value="exciseTax | currencyFilter" v-validate="'required'" />
                <vs-checkbox v-model="isExcisetax_apply"></vs-checkbox>
              </div>
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 flex items-center justify-around p-6">
                County Tax:
                <vs-input type="number" disabled class="min-w-max ml-2" :value="countytax | currencyFilter" v-validate="'required'" />
                <vs-checkbox v-model="isCountrytax_apply" :disabled="verifyCheckboxDisable('county_tax')"></vs-checkbox>
              </div>
            </div>
          </div>

          <!-- invoice summary and actions -->
          <div class="tax__panel border border-solid rounded mt-5">
            <div class="vx-row m-0 xl:justify-between justify-start">
              <div class="vx-col xl:w-auto lg:w-1/4 w-1/3 text-center p-2">
                Quantity:
                <p>
                  <b>{{ total_quantity | weightFilter }}</b>
                </p>
              </div>

              <div class="vx-col xl:w-auto lg:w-1/4 w-1/3 text-center p-2">
                Sub Total:
                <p>
                  <b>{{ plain_sub_total | currencyFilter }}</b>
                </p>
              </div>

              <div class="vx-col xl:w-auto lg:w-1/4 w-1/3 text-center p-2">
                Total Discount:
                <p>
                  <b>$ {{ total_discount | currencyFilter }}</b>
                </p>
              </div>

              <div class="vx-col xl:w-auto lg:w-1/4 w-1/3 text-center p-2">
                Redeem Point Discount:
                <p>
                  <b>$ {{ totalRedeemAmount | currencyFilter }}</b>
                </p>
              </div>

              <div class="vx-col xl:w-auto lg:w-1/4 w-1/3 text-center p-2">
                Tax Amount:
                <p>
                  <b>$ {{ total_tax | currencyFilter }}</b>
                </p>
              </div>

              <div class="vx-col xl:w-auto lg:w-1/4 w-1/3 text-center p-2">
                Grand Total:
                <p>
                  <b>$ {{ grand_total | currencyFilter }}</b>
                </p>
              </div>
            </div>

            <!-- actions -->
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/2 lg:w-1/3 flex items-center justify-around p-2">
                <vs-button type="filled" line-origin="left" color="danger" icon-pack="feather" icon="icon-pause" @click="holdInvoice"> Hold </vs-button>
              </div>
              <div class="vx-col w-full md:w-1/2 lg:w-1/3 flex items-center justify-around p-2">
                <vs-button v-if="!RETAILER_SUB_USER.includes(user.roleId)" type="filled" line-origin="left" color="success" icon-pack="feather" icon="icon-bookmark" @click="payLaterInvoice">
                  Pay Later
                </vs-button>
              </div>
              <div class="vx-col w-full md:w-1/2 lg:w-1/3 flex items-center justify-around p-2">
                <vs-button type="filled" line-origin="left" color="warning" icon-pack="feather" icon="icon-dollar-sign" @click="payInvoice"> Cash </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- category list -->
    <div class="p-2 w-4/12" v-if="customer">
      <CustomerDetails :customer="customer" />
    </div>

    <!-- discount setting model -->
    <DiscountSettingModal v-if="isDiscountSettingModalMounted" :isModalShow.sync="isDiscountSettingModalShow" :item="selectedItem.itemData" @update-item-discount="handleProductDiscountUpdate" />

    <!-- Popup Model - for select batch number in plants -->
    <product-plants
      v-if="isProductPlantModalMounted"
      :is_popup_active_select_plant_batch.sync="is_popup_active_select_plant_batch"
      :selectedPlants="selectedItemsSelectedPlants"
      :products_active_plants="products_active_plants"
      @addPlantsBatch="addPlantsBatch"
    />

    <!-- Popup Model - for create invoice -->
    <invoice-payment @sale-created="forceUpdate" :is_popup_active.sync="is_popup_active" :invoice__products="invoice__products" :modelType="model_type" :customer="customer" />

    <!-- Hold Invoices List -->
    <hold-invoice-list />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { routeMixins } from '@/mixins/route'
import { weightTypes, weightMixins } from '@/utils/weightType'
import { taxMode, discountApplicableType } from '@/utils/enums'
import { categoryTypesVersion2 } from '@/utils/categories'
import { RETAILER_SUB_USER, GROWER_SUB_USER, PROCESSOR_SUB_USER } from '@/utils/roles'
import { paymentMixins } from '@/utils/paymentTypes'
import DiscountSettingModal from '@/views/pos/components/POS/DiscountSettingModal'
import ProductList from '@/views/pos/components/POS/ProductList.vue'
import ProductPlants from '@/views/pos/components/POS/ProductPlantsPopup.vue'
import InvoicePayment from '@/views/pos/components/POS/InvoicePaymentpopup.vue'
import HoldInvoiceList from '@/views/pos/components/HoldInvoice/HoldInvoicesList.vue'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import PosHeader from '@/views/pos/components/POS/PosHeader.vue'
import { posFunctions } from '@/views/pos/posFunctions'
import CustomerDetails from '@/views/pos/components/POS/CustomerDetails.vue'

export default {
  // component name
  name: 'Pos',

  components: {
    Datepicker,
    ProductList,
    ProductPlants,
    InvoicePayment,
    HoldInvoiceList,
    Select2,
    VuePerfectScrollbar,
    DiscountSettingModal,
    PosHeader,
    CustomerDetails
  },

  props: {
    lastRecord: Object
  },

  // reference variables
  data: () => ({
    RETAILER_SUB_USER,
    GROWER_SUB_USER,
    PROCESSOR_SUB_USER,
    // customer
    customer: null,
    customerDetail: null,
    customerOptions: [],
    activeCustomerPurcehaseModel: false,

    // redeem points
    reedemType: null,
    redeemPointSettings: null,

    // invoice variables
    categoryTaxes: null,
    taxMode,
    invoice__products: [],
    weightTypesOptions: weightTypes,

    // tax panel variables
    cityTax: 0,
    stateTax: 0,
    exciseTax: 0,
    countytax: 0,

    isCitytax_apply: true,
    isStatetax_apply: true,
    isExcisetax_apply: true,
    isCountrytax_apply: true,

    // promotional discount
    promo_discount: [],

    // popups
    is_popup_active: false,

    // product plant popup
    selectedItemsSelectedPlants: [],
    isProductPlantModalMounted: false,
    is_popup_active_select_plant_batch: false,
    model_type: null,

    // plants batch number
    products_plants: [],
    plantIds: [],
    current_selected_products: null,

    // discount modal
    selectedItem: null,
    isDiscountSettingModalMounted: false,
    isDiscountSettingModalShow: false
  }),

  mixins: [weightMixins, paymentMixins, routeMixins, posFunctions],

  // methods - invoke on load
  async mounted() {
    console.log('dsnfjdfhsdhfhhdsfuh')
    // get redeem point setting
    this.getRedeemPointsSetting()

    await this.getDiscountAndTaxOptions() // get discount and tax options
  },

  // methods - invoke on value changess
  computed: {
    ...mapState('product', ['categories']),
    ...mapState('pos', ['products']),
    ...mapState('auth', ['user']),

    // verify check box disable - based on client discount
    verifyCheckboxDisable() {
      return (taxType) => !!(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount[taxType])
    },

    findItemIndex() {
      return (productId) => this.invoice__products.findIndex((x) => x.id === productId)
    },

    // render sub total
    // per product
    // return = subtotal - discount
    render_sub_total() {
      return (product) => {
        // if tax mode = not included and discount type = pre tax --> deduct discount from sub total
        let subTotal = 0
        if (
          (this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && product.discountAmountType === discountApplicableType.preTax) ||
          (this.categoryTaxes.tax_mode === taxMode.taxIncluded && product.discountAmountType === discountApplicableType.preTax)
        ) {
          subTotal = product.sub_total - product.discountAmount - this.convertRedeemPointToDollar(product.item_redeem_points)
        } else {
          subTotal = product.sub_total - this.convertRedeemPointToDollar(product.item_redeem_points)
        }

        return Math.max(0, subTotal)
      }
    },

    // invoice sub total
    plain_sub_total() {
      return this.invoice__products.reduce((acc, product) => {
        acc += this.render_sub_total(product)
        return acc
      }, 0)
    },

    // calculate = quantity * price
    promotional_sub_total() {
      return (product) => {
        return product.price * Number(product.itemQuantity)
      }
    },

    // products plants
    products_active_plants() {
      return this.products_plants.filter((item) => item.status && !!item.plant && !item.plant.holdSalesPlant)
    },

    // count total inventory item
    total_quantity() {
      return this.invoice__products.reduce((acc, item) => {
        const tempQty = acc + item.itemQuantity
        return tempQty
      }, 0)
    },

    // count total tax = sum of all taxes
    total_tax() {
      const citytax = this.isCitytax_apply ? Number(this.cityTax) : 0
      const statetax = this.isStatetax_apply ? Number(this.stateTax) : 0
      const excisetax = this.isExcisetax_apply ? Number(this.exciseTax) : 0
      const countytax = this.isCountrytax_apply ? Number(this.countytax) : 0

      return paymentMixins.methods.mathRound(citytax + statetax + excisetax + countytax, 2)
    },

    // calculate total discount
    total_discount() {
      return this.invoice__products.reduce((acc, item) => acc + item.discountAmount, 0)
    },

    // calculate post tax discount
    calculate_post_tax_discount() {
      return this.invoice__products.reduce((acc, item) => {
        if (this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && item.discountAmountType === discountApplicableType.postTax) {
          acc += item.discountAmount
        }

        return acc
      }, 0)
    },

    /**
     * Grand total without redeem points
     */
    grandTotalWithoutRedeemPoints() {
      const total_sub_total = this.invoice__products.reduce((acc, item) => {
        let subTotal = 0
        if (
          (this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && item.discountAmountType === discountApplicableType.preTax) ||
          (this.categoryTaxes.tax_mode === taxMode.taxIncluded && item.discountAmountType === discountApplicableType.preTax)
        ) {
          subTotal = item.sub_total - item.discountAmount
        } else {
          subTotal = item.sub_total
        }

        acc += subTotal

        return acc
      }, 0)

      return total_sub_total + this.total_tax
    },

    /**
     * Grand total with redeem points calculation
     * calculate grand_total = (((sales price * qty) - discount) - redeem points) + taxes
     */
    grand_total() {
      const total_sub_total = this.invoice__products.reduce((acc, item) => acc + this.render_sub_total(item), 0)
      return total_sub_total + this.total_tax
    },

    // calculate total without discount = (total price * qty)
    calculate_sub_total_without_discount() {
      return this.invoice__products.reduce((acc, item) => {
        const tempTotal = this.promotional_sub_total(item)
        return acc + tempTotal
      }, 0)
    }
  },

  // all the methods and function - invoke upon actions
  methods: {
    ...mapActions('pos', {
      fetchCustomers: 'get_customers',
      fetchCustomerPOSHistory: 'get_customers_pos_hostory',
      create_holdInvoice: 'create_hold_invoice',
      fetch_hold_invoice_by_id: 'get_hold_invoice_by_id',
      update_holdInvoice: 'update_hold_invoice'
    }),
    ...mapMutations('pos', { removeItemsFromProducts: 'REMOVE_PRODUCTS' }),
    ...mapMutations('patient', { patientSETSTATE: 'SET_STATE' }),
    ...mapMutations('client', { clientSETSTATE: 'SET_STATE' }),
    ...mapActions('setting', ['getSystemDiscountAndTax']),

    async getDiscountAndTaxOptions() {
      const payload = { page: 1, limit: 0, search: null, order: ['tax_and_discount.id', 'ASC'], type: ['system', 'user'] }
      await this.getSystemDiscountAndTax(payload)
    },

    // toggle discount setting modal
    toggleDiscountSettingModal(data, index) {
      this.selectedItem = {
        itemData: data,
        index
      }

      this.isDiscountSettingModalMounted = true
      this.isDiscountSettingModalShow = true
    },

    // handle product discount update
    handleProductDiscountUpdate(data) {
      const product = this.invoice__products[this.selectedItem.index]

      if (data.discountAmountType === 'postTax') {
        if (
          (data.discountType === 2 && data.discount > product.price * product.itemQuantity - this.convertRedeemPointToDollar(product.item_redeem_points) + product.tax) ||
          (data.discountType === 1 && data.discount > 100)
        ) {
          this.$vs.notify({
            title: 'Error',
            text: "You can't apply more discount then subtotal",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          return false
        }
      } else if (
        (data.discountType === 2 && data.discount > product.price * product.itemQuantity - this.convertRedeemPointToDollar(product.item_redeem_points)) ||
        (data.discountType === 1 && data.discount > 100)
      ) {
        this.$vs.notify({
          title: 'Error',
          text: "You can't apply more discount then subtotal",
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      this.invoice__products[this.selectedItem.index].discountType = data.discountType
      this.invoice__products[this.selectedItem.index].discount = data.discount
      this.invoice__products[this.selectedItem.index].discountAmountType = data.discountAmountType

      this.$nextTick(() => {
        // update redeem points
        this.setRedeemPoints(this.redeemPoints)
        // calculate product tax
        this.calculate_product_tax()
      })
    },

    // handle customer change
    customerChangeHandler(item) {
      this.customer = item.value || item.id
      this.customerDetail = item

      // check discounts
      this.isCitytax_apply = !(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount.city_tax)
      this.isStatetax_apply = !(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount.state_tax)
      this.isCountrytax_apply = !(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount.county_tax)

      this.invoice__products.forEach((item) => {
        item.discount = this.customerDetail && this.customerDetail.taxDiscount ? this.customerDetail.taxDiscount.value : 0
        item.discountType = this.customerDetail && this.customerDetail.taxDiscount ? 1 : 2
      })

      this.$nextTick(() => {
        // calculate discount
        this.calculate_product_tax()
      })
    },

    // handle product price change
    productPriceChangeHandler(product, value) {
      product.sales_price = parseFloat(value)

      this.$nextTick(() => {
        // update redeem points
        this.setMaxRedeemPointsPerProduct()

        // calculate product tax
        this.calculate_product_tax()
      })
    },

    // handle product quantity change
    productQtyChangeHandler(product, index, value) {
      // check the max quantity limit - if limit meets then show error else increase quantity
      if (this.invoice__products[index].categoryId === this.categories.FLOWER || this.invoice__products[index].categoryId === this.categories.SHAKE) {
        if (!this.invoice__products[index].weight_type) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Weight type',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          return false
        }
      }

      const val = [this.categories.FLOWER, this.categories.SHAKE].includes(this.invoice__products[index].categoryId) ? Math.abs(value) : Math.ceil(Math.abs(value))

      if (this.invoice__products[index].maxAvailableQuantity < val) {
        // if item qunatity is more than max available quantity - set item quanity to max available quantity
        this.invoice__products[index].itemQuantity = weightMixins.methods.mathRound(this.invoice__products[index].maxAvailableQuantity, 3)
      } else {
        // if item quantity less than 0 - set item quantity to 0
        this.invoice__products[index].itemQuantity = val < 0.0 ? 0 : weightMixins.methods.mathRound(val, 3)
      }

      // update price
      product.price = this.calculate_product_discount(product)
      product.sub_total = product.price * Number(product.itemQuantity)

      this.$nextTick(() => {
        // update redeem points
        this.setMaxRedeemPointsPerProduct()

        // calculate product tax
        this.calculate_product_tax()
      })
    },

    // get customer POS history
    async getCustomerPosHistory() {
      try {
        localStorage.setItem('posCustomerId', this.customer)
        await this.fetchCustomerPOSHistory(this.customer)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // get redeem point settings
    async getRedeemPointsSetting() {
      this.$store.dispatch('setting/getRedeemPointValues').then((res) => {
        this.redeemPointSettings = res.data.rewardSetUp
      })
    },

    // increment available quantity
    async incrementAvailableQty(item, product) {
      const diff = weightMixins.methods.mathRound(item.maxAvailableQuantity - item.itemQuantity, 3)

      return product.categoryId === this.categories.FLOWER || product.categoryId === this.categories.SHAKE ? (diff > 0.5 ? 0.5 : diff) : diff > 1 ? 1 : diff
    },

    // add product items in invoice
    async addProductItemsInInvoice(productId) {
      const index = this.products.findIndex((x) => x.id === productId)

      const isproductPresentInInvoice = this.invoice__products.findIndex((item) => item.id === this.products[index].id && item.categoryId === this.products[index].categoryId)

      if ([this.categories.PLANT, this.categories.MATURE].includes(this.products[index].categoryId)) {
        this.selectedItemsSelectedPlants = isproductPresentInInvoice > -1 ? this.invoice__products[isproductPresentInInvoice].invoice_plants : []
        this.isProductPlantModalMounted = true
        this.is_popup_active_select_plant_batch = true
        this.products_plants = this.products[index].product_plants
        this.current_selected_products = this.products[index].id
      }

      // check product is added in invoice - if added then increase quanity else add product
      if (isproductPresentInInvoice > -1) {
        // verify the weight type before increase the quantity
        if (
          (this.products[index].categoryId === this.categories.FLOWER || this.products[index].categoryId === this.categories.SHAKE) &&
          !this.invoice__products[isproductPresentInInvoice].weight_type
        ) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Weight type',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          return false
        }

        // check the max quantity limit - if limit meets then show error else increase quantity
        if (this.invoice__products[isproductPresentInInvoice].itemQuantity <= this.invoice__products[isproductPresentInInvoice].maxAvailableQuantity) {
          if ([this.categories.PLANT, this.categories.MATURE].includes(this.products[index].categoryId)) {
            // this.invoice__products[isproductPresentInInvoice].itemQuantity = 0
          } else {
            this.invoice__products[isproductPresentInInvoice].itemQuantity =
              this.invoice__products[isproductPresentInInvoice].itemQuantity + (await this.incrementAvailableQty(this.invoice__products[isproductPresentInInvoice], this.products[index]))
          }

          // updates the product discount price
          this.productQtyChangeHandler(this.invoice__products[isproductPresentInInvoice], isproductPresentInInvoice, this.invoice__products[isproductPresentInInvoice].itemQuantity)

          // update total tax
          await this.calculate_product_tax()
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Oops! You have only 1 items in Stock',
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
            color: 'warning'
          })

          return false
        }
      } else {
        if (!this.categoryTaxes) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please setup tax setting',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          return false
        }

        if (!this.products[index].discount) {
          this.products[index].discount = this.customerDetail && this.customerDetail.taxDiscount ? this.customerDetail.taxDiscount.value : 0
          this.products[index].discountType = this.customerDetail && this.customerDetail.taxDiscount ? 1 : 2
          this.products[index].discountAmount = 0
          this.products[index].discountAmountType = discountApplicableType.postTax
        }

        this.products[index].itemQuantity = 0

        const temp_product_obj = { ...this.products[index] }

        temp_product_obj.maxAvailableQuantity = weightMixins.methods.mathRound(this.products[index].quantity, 3) //set the maximum quantity that can sell
        temp_product_obj.original_weight_type = temp_product_obj.weight_type

        // update price
        temp_product_obj.price = this.calculate_product_discount(temp_product_obj)
        temp_product_obj.original_sales_price = temp_product_obj.sales_price
        // updates the product discount price
        temp_product_obj.sub_total = 0
        temp_product_obj.total_tax_percentage = 0
        // update tax
        temp_product_obj.tax = 0

        // redeem points
        temp_product_obj.item_redeem_points = 0

        if ([this.categories.FLOWER, this.categories.SHAKE].includes(this.products[index].categoryId)) {
          temp_product_obj.weight_type = temp_product_obj.weight_type
        }
        this.invoice__products.push({ ...temp_product_obj })

        // update total tax
        await this.calculate_product_tax()
      }
    },

    // calculate product discount - return the price after discount applied
    calculate_product_discount(product) {
      let productItemQuantityGrams = product.itemQuantity
      if (product.categoryId !== this.categories.FLOWER || product.categoryId !== this.categories.SHAKE) {
        productItemQuantityGrams = this.convertAvailableQty(product.itemQuantity, product.weight_type)['grams']
      }

      if (product.tieredPricingGroupId && product.tieredPricingGroup) {
        // store discount in temp state for later use
        const productInvoiceIndex = this.findItemIndex(product.id)

        // check product qty
        const productDiscountObj = product.tieredPricingGroup.pricingFlows.find((x) => {
          if (x.weight_quantity === productItemQuantityGrams) {
            return true
          }

          if (productItemQuantityGrams >= x.weight_quantity && productItemQuantityGrams <= x.weight_quantity + product.tieredPricingGroup.weightHeavyAmount) {
            return true
          }
        })

        if (productDiscountObj) {
          this.promo_discount[productInvoiceIndex] = productDiscountObj
          return product.sales_price === product.original_sales_price ? productDiscountObj.pricing_value / productItemQuantityGrams : product.sales_price
        }
      }

      return product.sales_price === product.original_sales_price && product.original_weight_type !== product.weight_type
        ? this.convertPricePerWeight(product.original_weight_type, product.sales_price)[product.weight_type]
        : product.sales_price
    },

    // set current categories taxes
    async setCategoryTaxes(taxes) {
      if (!taxes) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please setup tax setting',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      this.categoryTaxes = taxes
    },

    // calculate tax of product
    calculate_product_tax() {
      // temp tax value
      this.cityTax = 0
      this.exciseTax = 0
      this.countytax = 0
      this.stateTax = 0

      this.invoice__products.forEach((product, index) => {
        const productCategory = product.categoryId

        const totalTax = ['excise_tax', 'state_tax', 'county_tax', 'city_tax'].reduce((acc, item) => {
          if (item === 'excise_tax' && this.isExcisetax_apply) {
            acc += this.categoryTaxes[item][categoryTypesVersion2[productCategory]].tax_per || 0
          }

          if (item === 'state_tax' && this.isStatetax_apply) {
            acc += this.categoryTaxes[item][categoryTypesVersion2[productCategory]].tax_per || 0
          }

          if (item === 'county_tax' && this.isCountrytax_apply) {
            acc += this.categoryTaxes[item][categoryTypesVersion2[productCategory]].tax_per || 0
          }

          if (item === 'city_tax' && this.isCitytax_apply) {
            acc += this.categoryTaxes[item][categoryTypesVersion2[productCategory]].tax_per || 0
          }

          return acc
        }, 0)

        // save tax rate
        product.total_tax_percentage = totalTax

        // refix the price (original price)
        product.price = this.calculate_product_discount(product) || 0
        product.sub_total = product.price * Number(product.itemQuantity)
        product.discountAmount = product.discountType === 1 ? (product.discount * product.sub_total) / 100 : Number(product.discount)

        // if tax mode == include -> reduce price
        if (this.categoryTaxes && this.categoryTaxes.tax_mode === taxMode.taxIncluded) {
          const productPrice = product.price

          // update new price
          this.invoice__products[index].price = (productPrice * 100) / (100 + totalTax)

          if (
            (this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && product.discountAmountType === discountApplicableType.postTax) ||
            (this.categoryTaxes.tax_mode === taxMode.taxIncluded && product.discountAmountType === discountApplicableType.postTax)
          ) {
            const subTotal = productPrice * product.itemQuantity
            product.discountAmount = product.discountType === 1 ? (product.discount * subTotal) / 100 : Number(product.discount)
            const priceRef = (subTotal - product.discountAmount) / (1 + totalTax / 100)
            this.invoice__products[index].sub_total = priceRef
          } else {
            this.invoice__products[index].sub_total = this.promotional_sub_total(this.invoice__products[index])
          }
        }

        if (this.categoryTaxes && this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && product.discountAmountType === discountApplicableType.postTax && product.discount > 0) {
          const subTotalTax = (product.sub_total * totalTax) / 100
          product.sub_total = product.sub_total + subTotalTax
          product.discountAmount = product.discountType === 1 ? (product.discount * product.sub_total) / 100 : Number(product.discount)
          product.sub_total = product.sub_total - product.discountAmount
          product.sub_total = product.sub_total / (1 + totalTax / 100)
        }

        let itemTotalTax = 0

        new Array('excise_tax', 'state_tax', 'county_tax', 'city_tax').forEach((element) => {
          // tax ratio
          const tempTax = this.categoryTaxes[element][categoryTypesVersion2[productCategory]].tax_per || 0

          // discount
          let tempDiscount = 0
          if (
            (this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && product.discountAmountType === discountApplicableType.preTax) ||
            (this.categoryTaxes.tax_mode === taxMode.taxIncluded && product.discountAmountType === discountApplicableType.preTax)
          ) {
            tempDiscount = product.discountAmount
          }

          // tax per item
          let taxAmount = (tempTax * (product.sub_total - tempDiscount - this.convertRedeemPointToDollar(product.item_redeem_points))) / 100
          taxAmount = Math.max(0, taxAmount)

          // update rax
          if (element === 'city_tax' && !(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount.city_tax)) {
            this.cityTax += taxAmount
            itemTotalTax += taxAmount
          }

          if (element === 'excise_tax') {
            this.exciseTax += taxAmount
            itemTotalTax += taxAmount
          }

          if (element === 'county_tax' && !(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount.county_tax)) {
            this.countytax += taxAmount
            itemTotalTax += taxAmount
          }

          if (element === 'state_tax' && !(this.customerDetail && this.customerDetail.taxDiscount && this.customerDetail.taxDiscount.state_tax)) {
            this.stateTax += taxAmount
            itemTotalTax += taxAmount
          }
        })

        // update price tax
        this.invoice__products[index].tax = itemTotalTax
      })
    },

    // calculate tax of single product - return requested tax
    calculate_single_product_tax(product, tax_type) {
      const taxType = this.categoryTaxes[tax_type]
      let tempTax = 0

      if (taxType) {
        // tax ratio
        tempTax = taxType[categoryTypesVersion2[product.categoryId]].tax_per || 0

        // discount
        let tempDiscount = 0
        if (
          (this.categoryTaxes.tax_mode === taxMode.taxNotIncluded && product.discountAmountType === discountApplicableType.preTax) ||
          (this.categoryTaxes.tax_mode === taxMode.taxIncluded && product.discountAmountType === discountApplicableType.preTax)
        ) {
          tempDiscount = product.discountAmount
        }

        return this.grand_total === 0 ? 0 : (tempTax * (product.sub_total - tempDiscount - this.convertRedeemPointToDollar(product.item_redeem_points))) / 100
      }

      return paymentMixins.methods.mathRound(tempTax, 2)
    },

    // delete or remove product item from invoice
    async removeProductFromInvoice(index) {
      const tempItemIndex = this.invoice__products[index].id
      await this.removeItemsFromProducts(tempItemIndex)

      this.$nextTick(() => {
        this.invoice__products.splice(index, 1)

        // calculate redeem modal
        this.setMaxRedeemPointsPerProduct()

        // update total tax
        this.calculate_product_tax()
      })
    },

    // add products plants
    async addPlantsBatch(plantIds) {
      // find the index from invoice invoice products array
      const isproductPresentInInvoice = this.invoice__products.findIndex(
        (item) => item.id === this.current_selected_products && [this.categories.PLANT, this.categories.MATURE].includes(item.categoryId)
      )

      // if index found - set the quantity and add the selected plants
      if (isproductPresentInInvoice > -1) {
        this.invoice__products[isproductPresentInInvoice].itemQuantity = plantIds.length
        this.invoice__products[isproductPresentInInvoice].invoice_plants = plantIds.length ? plantIds : []
        this.productQtyChangeHandler(this.invoice__products[isproductPresentInInvoice], isproductPresentInInvoice, plantIds.length)
      }

      // update total tax
      await this.calculate_product_tax()

      // clear temp products array
      plantIds = []
      this.is_popup_active_select_plant_batch = false
    },

    // change weight type and calculate quantity
    async changeWeightType(index, value) {
      const product = this.products.find((element) => element.id === this.invoice__products[index].id)
      const weight = this.convertAvailableQty(product.quantity, product.weight_type)[value] // calculate weight

      // reset item quantity and set item price by weight
      this.invoice__products[index].weight_type = value
      this.invoice__products[index].maxAvailableQuantity = weight
      this.invoice__products[index].itemQuantity = 0
      this.invoice__products[index].price = 0
      this.invoice__products[index].sales_price = this.invoice__products[index].original_sales_price

      this.$nextTick(() => {
        // update total tax
        this.calculate_product_tax()
      })
    },

    // validate weight types - and increase quantity
    async validateWeightType(index, value) {
      // check the max quantity limit - if limit meets then show error else increase quantity
      if (this.invoice__products[index].categoryId === this.categories.FLOWER || this.invoice__products[index].categoryId === this.categories.SHAKE) {
        if (!this.invoice__products[index].weight_type) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Weight type',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          return false
        }
      }

      const val = [this.categories.FLOWER, this.categories.SHAKE].includes(this.invoice__products[index].categoryId) ? Math.abs(value) : Math.ceil(Math.abs(value))

      if (this.invoice__products[index].maxAvailableQuantity < val) {
        // if item qunatity is more than max available quantity - set item quanity to max available quantity
        this.invoice__products[index].itemQuantity = weightMixins.methods.mathRound(this.invoice__products[index].maxAvailableQuantity, 3)
      } else {
        // if item quantity less than 0 - set item quantity to 0
        this.invoice__products[index].itemQuantity = val < 0.0 ? 0 : weightMixins.methods.mathRound(val, 3)
      }

      this.$nextTick(() => {
        // update total tax
        this.calculate_product_tax()
      })
    },

    // check - item weight selected
    async checkItemWeightSelected() {
      // check the weight type
      const response = this.invoice__products.some((item) => (item.categoryId === this.categories.FLOWER || item.categoryId === this.categories.SHAKE) && !item.weight_type)

      if (response) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Weight type',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      return true
    },

    // hold invoice
    async holdInvoice() {
      if (this.customer) {
        if (this.invoice__products.length > 0) {
          if (this.invoice__products.find((x) => x.itemQuantity <= 0)) {
            this.$vs.notify({
              title: 'Error',
              text: 'Please Add Quantity to Product!!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })

            return false
          }

          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Are you sure?',
            text: 'You want to hold this sales invoice!',
            acceptText: 'Yes, I am sure!',
            cancelText: 'No, cancel it!',
            accept: await this.create_or_update_hold_invoice
          })
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Items from List!!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Customer',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // Pay later invoice
    async payLaterInvoice() {
      if (this.customer) {
        if (this.invoice__products.length > 0) {
          if (this.invoice__products.find((x) => x.itemQuantity <= 0)) {
            this.$vs.notify({
              title: 'Error',
              text: 'Please Add Quantity to Product!!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })

            return false
          }

          // before payment check item weight is selected
          if (!(await this.checkItemWeightSelected())) {
            return false
          }

          this.paymentrows = []

          // add new payment note
          this.paymentrows.push({
            amount: 0,
            payment_type: null,
            payment_note: ''
          })

          // open model
          this.is_popup_active = true
          this.model_type = 'pay_later'
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Items from List!!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Customer',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // Pay invoice
    async payInvoice() {
      if (this.customer) {
        if (this.invoice__products.length > 0) {
          if (this.invoice__products.find((x) => x.itemQuantity <= 0)) {
            this.$vs.notify({
              title: 'Error',
              text: 'Please Add Quantity to Product!!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })

            return false
          }

          // before payment check item weight is selected
          if (!(await this.checkItemWeightSelected())) {
            return false
          }

          this.paymentrows = []

          // open model
          this.$nextTick(() => {
            this.is_popup_active = true
            this.model_type = 'pay_now'
          })
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Items from List!!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Customer',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // create hold invoice
    async create_or_update_hold_invoice() {
      // request obj
      const create_invoice = {}

      // reset the redeem point
      this.reedemType = null
      this.redeemPoints = 0

      // update redeem points
      this.setMaxRedeemPointsPerProduct()

      // calculate tax modal
      this.calculate_product_tax()

      // customer details
      const tempCustomer = this.$refs.pos_header.customerOptions.find((x) => x.id === this.customer)
      create_invoice.customerId = this.customer
      create_invoice.customer_type = tempCustomer.customer_type

      // sub total - sum(price * qty)
      create_invoice.sub_total = this.calculate_sub_total_without_discount

      // discount
      create_invoice.total_discount = this.total_discount

      // tax details
      create_invoice.total_taxes = this.total_tax
      create_invoice.total_city_tax = this.isCitytax_apply ? paymentMixins.methods.mathRound(Number(this.cityTax), 2) : 0
      create_invoice.total_state_tax = this.isStatetax_apply ? paymentMixins.methods.mathRound(Number(this.stateTax), 2) : 0
      create_invoice.total_excise_tax = this.isExcisetax_apply ? paymentMixins.methods.mathRound(Number(this.exciseTax), 2) : 0
      create_invoice.total_county_tax = this.isCountrytax_apply ? paymentMixins.methods.mathRound(Number(this.countytax), 2) : 0

      // grand total
      create_invoice.grand_total = this.grandTotalWithoutRedeemPoints

      // sales item arrays
      const holdItems = []

      this.invoice__products.forEach((element) => {
        const temp_product_obj = {}

        temp_product_obj.total_tax_percentage = element.total_tax_percentage
        temp_product_obj.productId = element.id
        temp_product_obj.batchId = element.batchId
        temp_product_obj.hold_qty = element.itemQuantity
        temp_product_obj.weight_type = element.weight_type
        temp_product_obj.price_per_unit = element.price

        const tempTotal = this.promotional_sub_total(element)
        temp_product_obj.total_per_unit = tempTotal

        temp_product_obj.city_tax = this.isCitytax_apply ? this.calculate_single_product_tax(element, 'city_tax') : 0
        temp_product_obj.state_tax = this.isStatetax_apply ? this.calculate_single_product_tax(element, 'state_tax') : 0
        temp_product_obj.excise_tax = this.isExcisetax_apply ? this.calculate_single_product_tax(element, 'excise_tax') : 0
        temp_product_obj.county_tax = this.isCountrytax_apply ? this.calculate_single_product_tax(element, 'county_tax') : 0

        temp_product_obj.discountType = element.discountType === 1 ? 'percentage' : 'dollar'
        temp_product_obj.discount = element.discount
        temp_product_obj.discount_amount_type = element.discountAmountType

        const tempDiscount = element.discountAmount
        temp_product_obj.discount_amt = tempDiscount
        temp_product_obj.total_tax = temp_product_obj.city_tax + temp_product_obj.state_tax + temp_product_obj.excise_tax + temp_product_obj.county_tax
        temp_product_obj.total_cost = temp_product_obj.total_per_unit + temp_product_obj.total_tax - temp_product_obj.discount_amt

        if ([this.categories.PLANT, this.categories.MATURE].includes(element.categoryId)) {
          const plantIds = []
          if (element.invoice_plants.length) {
            element.invoice_plants.forEach((element) => {
              plantIds.push(element.plantId)
            })
          }
          temp_product_obj.plantIds = plantIds
        }

        holdItems.push(temp_product_obj)
      })

      create_invoice.holdItems = holdItems

      try {
        const { message } = await this.create_holdInvoice(create_invoice)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.is_popup_active = false
        localStorage.removeItem('posCustomerId')
        this.$router.go()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // remove all taxes from the invoice
    removeAllTaxsFromProducts() {
      this.cityTax = 0
      this.stateTax = 0
      this.exciseTax = 0
      this.countytax = 0
    }
  },

  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  },

  // watchers
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#pos',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#pos > .con-vs-loading')
      }
    },

    customer: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getCustomerPosHistory()
        }
      }
    },

    // handle callback for discount setting modal
    isDiscountSettingModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isDiscountSettingModalMounted = false
            this.selectedItem = null
          }, 0)
        }
      }
    },

    is_popup_active_select_plant_batch: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.selectedItemsSelectedPlants = []
          setTimeout(() => {
            this.isProductPlantModalMounted = false
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.is_popup_active_create_customer = false
    this.is_popup_active_select_plant_batch = false
    this.is_popup_active = false
    this.is_popup_hold_invoice_open = false
    this.isDiscountSettingModalShow = false
    this.isProductPlantModalMounted = false

    this.patientSETSTATE({
      action: 'patients',
      data: []
    })

    this.clientSETSTATE({
      action: 'clients',
      data: []
    })

    next()
  }
}
</script>

<style lang="scss">
.search_input {
  input {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}

.pos-product {
  .pos-product-item {
    background-color: rgba(0, 0, 0, 0.4);
  }
}

#pos {
  .invoice-col-height {
    // height: 100%;
    height: calc(100vh - 166px);
  }

  .reward-points {
    .vs-radio--label {
      line-height: 3rem;
    }
  }

  .invoice__product__details {
    border-color: rgba(0, 0, 0, 0.2);

    .vs-con-tbody {
      max-height: 375px;

      .product_name {
        min-width: 160px;
      }

      .weight_types {
        min-width: 150px;
      }

      .itemQuantity {
        max-width: 100px;
        input {
          text-align: right;
        }
      }

      .price {
        min-width: 100px;
        text-align: right;

        input {
          text-align: right;
        }
      }
    }

    table {
      border-collapse: unset !important;
      border-spacing: 0px;
    }

    thead {
      color: #fff;

      tr {
        background: rgb(0, 102, 34);

        th {
          border: 1px #fff solid;
        }
      }
    }
  }

  .tax__panel {
    border-color: rgba(0, 0, 0, 0.2);

    .invoice__action_btn {
      width: 70%;
    }
  }

  .grid {
    height: 100%;
    grid-auto-rows: 150px;
    overflow: auto;
    grid-template-columns: repeat(3, minmax(150px, 1fr)) !important;

    .pos-product {
      #overlay {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2;
        cursor: pointer;
        position: relative;

        .product_name {
          color: #fff;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 10px;
        }
        .product_price {
          color: #fff;
          background: rgb(0, 102, 34);
          position: absolute;
          padding: 0px 5px;
          border-radius: 5px;
          top: 1%;
          font-size: 8px;
        }
      }
    }
  }
}
</style>
